import type { ListingTemplateProduct } from "@/lib/listing-templates";
import CleanCommerceTemplate from "./templates/CleanCommerceTemplate";
import PremiumBrandTemplate from "./templates/PremiumBrandTemplate";
import MarketplaceClassicTemplate from "./templates/MarketplaceClassicTemplate";
import ProductFocusTemplate from "./templates/ProductFocusTemplate";
import DetailedTechnicalTemplate from "./templates/DetailedTechnicalTemplate";
import SoftPastelTemplate from "./templates/SoftPastelTemplate";

/** Maps a template id to its renderer, falling back to Clean Commerce. */
export default function TemplateRenderer({
  templateId,
  product,
}: {
  templateId: string;
  product: ListingTemplateProduct;
}) {
  switch (templateId) {
    case "premium-brand":
      return <PremiumBrandTemplate product={product} />;
    case "marketplace-classic":
      return <MarketplaceClassicTemplate product={product} />;
    case "product-focus":
      return <ProductFocusTemplate product={product} />;
    case "detailed-technical":
      return <DetailedTechnicalTemplate product={product} />;
    case "soft-pastel":
      return <SoftPastelTemplate product={product} />;
    case "clean-commerce":
    default:
      return <CleanCommerceTemplate product={product} />;
  }
}